import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import type { Avatar, IconAvatar, ImageAvatar, InitialsAvatar } from '../../types/avatar.type';
import { DEFAULT_INITIALS_AVATAR } from '../../types/avatar.type';
import { Maybe, ValueOf } from '../../types/base/';
import { IconComponent } from '../icon/icon.component';

export const avatarSizeOptions = {
  SMALL: 'sm',
  /** default value */
  MEDIUM: 'md',
  LARGE: 'lg',
  XLARGE: 'xl',
} as const;
export type AvatarSizeOption = ValueOf<typeof avatarSizeOptions>;

@Component({
  imports: [IconComponent],
  selector: 'evc-avatar',
  templateUrl: 'avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  imageHeight = input('100%');
  imageWidth = input('100%');
  enableBorder = input(true);
  size = input<AvatarSizeOption>(avatarSizeOptions.MEDIUM);
  color = input<Maybe<string>>();

  @Input({ required: true }) public set avatar(value: Avatar | undefined) {
    this._avatar = value || DEFAULT_INITIALS_AVATAR;
  }

  private _avatar: Avatar = DEFAULT_INITIALS_AVATAR;

  public get avatarInitials(): InitialsAvatar | undefined {
    if (this._avatar.type === 'initials') {
      return this._avatar;
    }

    return undefined;
  }

  public get avatarImage(): ImageAvatar | undefined {
    if (this._avatar.type === 'image') {
      return this._avatar;
    }

    return undefined;
  }

  public get avatarIcon(): IconAvatar | undefined {
    if (this._avatar.type === 'icon') {
      return this._avatar;
    }

    return undefined;
  }
}
